import axiosClient from "../api/axiosClient";

const base = "/Rooms/non-public-access-requests";
export const listRoomAccessRequests = (params, signal) => axiosClient.get(base, { params, signal });
export const getRoomAccessRequest = (id, signal) => axiosClient.get(`${base}/${id}`, { signal });
export const approveRoomAccessRequest = (id) => axiosClient.post(`${base}/${id}/approve`);
export const rejectRoomAccessRequest = (id, reason) => axiosClient.post(`${base}/${id}/reject`, { Reason: reason });
export const getRoomRequestSettings = (signal) => axiosClient.get("/Rooms/non-public-request-settings", { signal });
export const setRoomRequestSettings = (enabled) => axiosClient.put("/Rooms/non-public-request-settings", { IsNonPublicRequestReminderEnabled: enabled });
export const downloadRoomRequestDocument = (id, signal) => axiosClient.get(`${base}/${id}/document`, { responseType: "blob", ...(signal ? { signal } : {}) });
